import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  name: {
    description: 'manageTagsModal.name',
    defaultMessage: 'Name',
    id: '6CICVQ',
  },
  manageTagsTitle: {
    description: 'manageTagsModal.title',
    defaultMessage: 'Manage Tags',
    id: '5WOm3N',
  },
  noTagsMessage: {
    description: 'manageTagsModal.noTagsMessage',
    defaultMessage: 'No tags have been added.',
    id: 'X970Lj',
  },
  addTagsButton: {
    description: 'manageTagsModal.addTags',
    defaultMessage: 'Add Tags',
    id: 'qID8ws',
  },
  doneButton: {
    description: 'manageTagsModal.done',
    defaultMessage: 'Done',
    id: 'ir+jwI',
  },
  deleteTagErrorTitle: {
    description: 'manageTagsModal.deleteTagErrorTitle',
    defaultMessage: 'Delete Tag Error',
    id: 'zT7mUp',
  },
  deleteTagErrorMessage: {
    description: 'manageTagsModal.deleteTagErrorMessage',
    defaultMessage: 'The tag could not be deleted at this time. Please try again.',
    id: 'bImpP/',
  },
});
